import { Injectable } from '@angular/core';
import { ApiService } from './api';

import { Horse } from '../model/horse';
import { HorseBreeder } from '../model/horseBreeder';
import { HorseOwner } from '../model/horseOwner';
import { Rodeo } from '../model/rodeo';

@Injectable()
export class HorseService {
    constructor(private api: ApiService) { }

    async searchHorseByAQHAId(horseId: number, registrationNumber: string) {
        const url = `${this.api.endpoints.horses}/searchHorseByAQHAId?horseId=${horseId}&aqhaId=${registrationNumber}`;
        return await this.api.getWithAuth<Horse>(url);
    }

    async searchHorseByAQHAName(horseId: number, registeredName: string) {
        const url = `${this.api.endpoints.horses}/searchHorseByAQHAName?horseId=${horseId}&name=${registeredName}`;
        return await this.api.getWithAuth<Horse>(url);
    }

    async searchHorses(name: string, siresOnly: boolean, damsOnly: boolean) : Promise<Horse[]> {
        const url = `${this.api.endpoints.search}/horses?name=${name}&siresOnly=${siresOnly}&damsOnly=${damsOnly}`;
        return await this.api.getWithAuth<Horse[]>(url);
    }

    async searchBreeders(name: string) : Promise<HorseBreeder[]> {
        const url = `${this.api.endpoints.search}/breeders?name=${name}`;
        return await this.api.getWithAuth<HorseBreeder[]>(url);
    }

    async searchOwners(name: string) : Promise<HorseOwner[]> {
        const url = `${this.api.endpoints.search}/owners?name=${name}`;
        return await this.api.getWithAuth<HorseOwner[]>(url);
    }

    async getHorses(accountIds: number[]) : Promise<Horse[]> {
        return await
            this.api
                .postWithAuth<Horse[]>(this.api.endpoints.horses + '/getHorsesByAccountIds', accountIds);
    }

    async getHorseById(horseId: number) : Promise<Horse> {
        return await
            this.api
                .postWithAuth<Horse>(this.api.endpoints.horses + '/getHorseById', horseId);
    }

    async getNominatedHorseEntries(stallionId: number) {
        return await
        this.api
            .getWithAuth<Rodeo[]>(this.api.endpoints.horses + '/getNominatedHorseEntries?stallionId=' + stallionId);
    }

    addHorse(accountId : number, horse: Horse) {
        return new Promise((resolve, reject) => {
            this.api
                .postWithAuth(this.api.endpoints.horses + '/create' + '?accountId=' + accountId, horse)
                .then(data => resolve(data), error => reject(error));
        });
    }

    updateHorse(horse: Horse) {
        return new Promise((resolve, reject) => {
            this.api
                .putWithAuth(this.api.endpoints.horses + '/update', horse)
                .then(data => resolve(data), error => reject(error));
        });
    }

    deleteHorse(accountId: number, horseId: number) {
        return new Promise((resolve, reject) => {
            this.api
                .deleteWithAuth(this.api.endpoints.horses + '/delete?accountId=' + accountId + '&horseId=' + horseId)
                .then(data => resolve(data), error => reject(error));
        });
    }

    async addHorseOwner(horseOwner: HorseOwner) {
        return await
            this.api
                .postWithAuth(this.api.endpoints.horses + '/createHorseOwner', horseOwner);
    }

    async updateHorseOwner(horseOwner: HorseOwner) {
        return await this.api
            .postWithAuth(this.api.endpoints.horses + '/updateHorseOwner', horseOwner);
    }

    async addHorseBreeder(horseBreeder: HorseBreeder) {
        return await
            this.api
                .postWithAuth(this.api.endpoints.horses + '/createHorseBreeder', horseBreeder);
    }

    async updateHorseBreeder(horseBreeder: HorseBreeder) {
        return await this.api
            .postWithAuth(this.api.endpoints.horses + '/updateHorseBreeder', horseBreeder);
    }
}



// WEBPACK FOOTER //
// ./src/services/horse.service.ts